/**
 * Text utility functions for dynamic content generation
 */

import constant from './constant';

/**
 * Generate top page description with theme replacements
 * @param {Object} themeConfig - Theme configuration object
 * @returns {string} - Formatted description
 */
export const generateTopPageDescription = (themeConfig) => {
  if (!themeConfig) return '';
  
  return constant.TOP_PAGE_DESC
    .replace(/___NFT_PLURAL___/g, themeConfig.APP_NFT_PLURAL || 'NFTs')
    .replace(/___BENEFICIARY___/g, themeConfig.APP_BENEFICIARY || 'beneficiary')
    .replace(/___PURPOSE___/g, themeConfig.APP_PURPOSE || 'fundraising')
    .replace(/___CAMPAIGN___/g, themeConfig.APP_CAMPAIGN_NAME || 'campaign');
};

/**
 * Truncate text with ellipsis
 * @param {string} text - Text to truncate
 * @param {number} maxLength - Maximum length
 * @returns {string} - Truncated text
 */
export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
};

/**
 * Format address for display
 * @param {string} address - Wallet address
 * @param {number} startChars - Characters to show at start
 * @param {number} endChars - Characters to show at end
 * @returns {string} - Formatted address
 */
export const formatAddress = (address, startChars = 6, endChars = 4) => {
  if (!address || address.length <= startChars + endChars) return address;
  return `${address.slice(0, startChars)}...${address.slice(-endChars)}`;
};
